import {
  CTypeOptionCheckout,
  IFee,
} from '@/dataSource/src/api/payment-link/entities';

export const mockPaymentLinkFeeVenmo: IFee = {
  type: CTypeOptionCheckout.VENMO,
  percentage_fee: 1,
  flat_fee: 0,
};

export const mockPaymentLinkFees: IFee[] = [
  {
    type: CTypeOptionCheckout.DEBIT_CARD,
    flat_fee: 0.5,
    percentage_fee: 0,
  },
  mockPaymentLinkFeeVenmo,
  {
    type: CTypeOptionCheckout.CREDIT_CARD,
    flat_fee: 0.5,
    percentage_fee: 3,
  },
  {
    type: CTypeOptionCheckout.APPLE_PAY,
    flat_fee: 0.5,
    percentage_fee: 3,
  },
  {
    type: CTypeOptionCheckout.GOOGLE_PAY,
    flat_fee: 0.5,
    percentage_fee: 3,
  },
];
